import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

/**
 * Visual section of a menu — wraps base-ui's accessibility `Group` and applies
 * the design-system padding/gap. Wrap one or more `Item`/`CheckboxItem`/
 * `RadioItem` children, optionally preceded by a `GroupLabel`.
 */
export const Group = ({ className, ...props }: BaseMenu.Group.Props) => {
  return (
    <BaseMenu.Group
      className={cn('flex flex-col gap-[1px] p-0', className)}
      {...props}
    />
  )
}
